import { createEffectFn } from '@ngneat/effects';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap } from 'rxjs';
import { accountsService } from './account.service';
import { AccountState } from './account.store';

type SearchAccountParams = Partial<AccountState>

export const searchAccountEffect = createEffectFn((params$: Observable<SearchAccountParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => accountsService.getAccounts().pipe(catchError(() => EMPTY)))
  );
});
